import React from "react";
import { useNavigate } from "react-router-dom";
import LoanSteps from "./Loansteps";
import CallToAction from "./CallToAction";

const GoldLoanInfo = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="other-pages-main-section">
                <h2 className="other-pages-title">Gold Loan</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/gold-loan-mumbai-thane-palghar-maharashtra-delhi-india")} style={{ cursor: "pointer" }}>Gold Loan</span>
                </p>
            </div>

            <div className="info-loan-card-smco">
                <h2 className="info-loan-title-smco">What is a Gold Loan?</h2>

                <p className="info-loan-description-smco">
                    A gold loan is a secured loan where borrowers pledge their gold ornaments or coins as collateral to avail funds from banks or non-banking financial companies (NBFCs). It is one of the fastest and easiest ways to access short-term credit, especially in times of financial emergencies. The loan amount sanctioned is a percentage of the gold's market value, known as the Loan-to-Value (LTV) ratio, typically ranging from 75% to 90%.
                    <br /><br />
                    Gold loans are popular in India due to the widespread ownership of gold and the relatively lenient eligibility criteria. The loan tenure can range from a few months to a few years, and the borrower can repay the loan in various ways such as monthly EMIs, interest-only payments, or bullet repayments. Unlike personal loans, gold loans offer lower interest rates since the lender holds collateral in the form of gold.
                    <br /><br />
                    The gold pledged is safely stored by the lender for the duration of the loan and is returned to the borrower upon complete repayment. In case of default, the lender has the right to auction the gold to recover the outstanding loan amount. Therefore, timely repayment is essential. Gold loans can be a smart financial option for individuals looking to leverage their idle gold assets without having to sell them.
                    <br /><br />
                    These loans are often used for medical emergencies, educational expenses, business needs, or even personal consumption. Processing is quick, often completed within hours, with minimal documentation. Whether you are salaried, self-employed, or a homemaker, a gold loan can provide the liquidity you need while keeping your assets secure.
                </p>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Key Features of a Gold Loan</h3>
                    <ul className="info-feature-list-smco">
                        <li><strong>Secured loan:</strong> Backed by physical gold as collateral, reducing lender risk.</li>
                        <li><strong>High LTV ratio:</strong> You can get up to 90% of the gold’s current market value as a loan.</li>
                        <li><strong>Quick disbursal:</strong> Loan is approved and disbursed within a few hours in most cases.</li>
                        <li><strong>Flexible repayment options:</strong> Choose from EMIs, interest-only, or lump sum repayments.</li>
                        <li><strong>Minimal paperwork:</strong> Basic KYC documents are usually enough for processing.</li>
                        <li><strong>No income proof required:</strong> Suitable for all income groups, including homemakers and farmers.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Eligibility Criteria</h3>
                    <ul className="info-eligibility-list-smco">
                        <li><strong>Age:</strong> Applicant should be between 18 to 70 years old.</li>
                        <li><strong>Gold quality:</strong> Only gold jewelry and coins (usually up to 50 grams) of 18 to 24 karat purity are accepted.</li>
                        <li><strong>Ownership:</strong> The gold must legally belong to the applicant.</li>
                        <li><strong>KYC compliance:</strong> PAN card, Aadhaar card, voter ID, or driver’s license is generally required.</li>
                    </ul>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Interest Rates and Charges</h3>
                    <p>
                        Interest rates on gold loans typically range from 7% to 15% per annum, depending on the lender and tenure. Some lenders may also charge processing fees (usually 0.5% to 2%), valuation fees, and penal interest for late repayment. Compared to personal loans, the interest is usually lower due to the secured nature of the loan.
                    </p>
                </div>

                <div className="info-section-smco">
                    <h3 className="info-section-title-smco">Benefits of Gold Loans</h3>
                    <ul className="info-benefits-list-smco">
                        <li><strong>Instant liquidity:</strong> Turn your idle gold into active cash without selling it.</li>
                        <li><strong>Lower interest rate:</strong> Gold loans offer more affordable rates compared to unsecured loans.</li>
                        <li><strong>Short processing time:</strong> Ideal for urgent financial needs, with same-day disbursal in many cases.</li>
                        <li><strong>No credit check:</strong> Suitable for those with low or no credit score, as approval is based on the gold’s value.</li>
                        <li><strong>Safe asset storage:</strong> Your pledged gold is stored securely in bank lockers or insured vaults until the loan is repaid.</li>
                    </ul>
                </div>
            </div>

            <LoanSteps />
            <CallToAction />
        </>
    );
};

export default GoldLoanInfo;
